import type { BlockNumericalFacts } from 'types/block-numerical-facts';

import { Paragraph, Wrap } from '@leafwell/components';

import HeadingBody from './heading-body';
import { getRandomInt } from 'lib/utils/generateRandomInt';
import Figure from './figure';

const NumericalFacts: React.FC<BlockNumericalFacts> = ({
  sectionId,
  title,
  description,
  backgroundColor,
  facts,
}) => {
  const lessFacts = facts?.length && facts?.length < 4;

  return (
    <section
      id={sectionId}
      className={[
        backgroundColor === 'green'
          ? 'bg-dark-green-gradient my-12 md:my-16'
          : 'bg-white',
      ].join(' ')}
    >
      <Wrap className="gap-y-16">
        {title || description ? (
          <div className="grid gap-y-6 justify-items-center">
            {title && (
              <HeadingBody
                level="2"
                tagName="h2"
                title={title}
                className={[
                  'font-semibold text-center lg:max-w-5xl',
                  backgroundColor === 'green' ? 'text-white' : 'text-black',
                ].join(' ')}
              />
            )}
            {description && (
              <HeadingBody
                level="6"
                tagName="p"
                title={description}
                className={[
                  'text-center',
                  backgroundColor === 'green' ? 'text-white' : 'text-gray-700',
                ].join(' ')}
              />
            )}
          </div>
        ) : null}
        {facts?.length > 0 ? (
          <ul
            className={[
              'flex flex-col md:flex-row flex-wrap items-center md:items-start justify-center gap-y-8 gap-x-8',
            ].join(' ')}
          >
            {facts.map(({ fact, factDescription, icon }) => {
              const idx = getRandomInt(1, 1000000);
              return (
                <li
                  key={`${idx}-fact`}
                  className="flex flex-col items-center gap-y-3"
                >
                  {icon && lessFacts && (
                    <Figure
                      {...icon}
                      className="inline-flex md:w-100 md:min-h-52 justify-center items-end"
                    />
                  )}
                  <div>
                    <Paragraph
                      tagName="h4"
                      className={[
                        'font-semibold text-center !text-3xl',
                        backgroundColor === 'green'
                          ? 'text-white'
                          : 'text-black',
                      ].join(' ')}
                    >
                      {fact}
                    </Paragraph>
                    <Paragraph
                      tagName="div"
                      className={[
                        'text-center !text-xl',
                        lessFacts ? 'md:max-w-80' : 'md:max-w-60',
                        backgroundColor === 'green'
                          ? 'text-white'
                          : 'text-gray-700',
                      ].join(' ')}
                      dangerouslySetInnerHTML={{ __html: factDescription }}
                    />
                  </div>
                </li>
              );
            })}
          </ul>
        ) : null}
      </Wrap>
    </section>
  );
};

export default NumericalFacts;
